<template>
  <div>
    <div class="column-acoes">
      <el-dropdown trigger="click" :disabled="this.desabilitaAbrirAcoes">
        <span :style="`color: ${estilo.aplicacao.corPrimariaAplicacao}`" class="el-dropdown-link" :class="{ 'is-disabled': this.desabilitaAbrirAcoes }">Ações <i class="el-icon-more"></i></span>
        <el-dropdown-menu slot="dropdown" class="acoes-dropdown">
          <el-dropdown-item v-for="(acao, index) in columnAcoes" :key="index">
            <el-button v-show="('show' in acao)? acao.show : true" type="text" @click="acao.func(row)">{{acao.label}}</el-button>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-button type="text"></el-button>
    </div>
    <ModalEnvio
      :open.sync="mostraEnvio"
      title="Selecionar Envio"
      width="523px"
      @close="mostraEnvio = false"
      :close-on-click-modal="true"
      :destroy-on-close="true"
      :payloadWidget="()=>{return carregaPayloadWidget(row)}"
    >
    </ModalEnvio>
  </div>
</template>
<style scoped>
.grid-content {
  min-height: 36px;
}
.is-disabled {
  color: #bbb !important;
  pointer-events: none !important;
}
</style>
<script>
import { mapGetters, mapState } from 'vuex'
import { EnumCanalAtendimentoOrigem } from '@/constants/EnumCanalAtendimentoOrigem'
import ModalEnvio from '@/components/ModalEnvio/ModalEnvio'
import ArrowButton from '@/components/listagemColumn/ArrowButton'
import { preloadWidget } from '@/views/14/PreLoadWidget14'

export default {
  name: 'AcoesDebito',
  props: ['column', 'row'],
  components: { ModalEnvio },
  data () {
    return {
      mostraEnvio: false,
      payloadWidget: {}
    }
  },
  computed: {
    ...mapGetters('SetupApp', ['estilo', 'canalAtendimentoOrigem']),
    ...mapState('SetupApp', ['funcionalidade', 'apiFuncionalidade', 'frameId', 'embedJson']),
    columnAcoes () {
      switch (this.canalAtendimentoOrigem) {
        case EnumCanalAtendimentoOrigem.MOSIA_DESK:
          return this.menuMosiaDesk
        default:
          return { field: '', component: ArrowButton, acao: this.clickDetalhe }
      }
    },
    menuMosiaDesk () {
      const payloadMenu = []
      if (
        this.funcionalidade.parametros.configuracoesDeWidgets.permiteEnvioChatWidget ||
        this.funcionalidade.parametros.configuracoesDeWidgets.permiteEnvioEmailWidget ||
        this.funcionalidade.parametros.configuracoesDeWidgets.permiteEnvioWhatsappWidget
      ) {
        payloadMenu.push({ label: 'Enviar', func: this.abreDialogEnvio })
      }
      if (this.funcionalidade.parametros.configuracoesDeWidgets.exibeDetalheWidget) {
        payloadMenu.push({ label: 'Detalhes', func: this.clickDetalhe })
      }
      return payloadMenu
    },
    desabilitaEnviar () {
      return !(this.opcaoEnvio !== '' && (this.escolhasEnvio.length > 0))
    },
    desabilitaAbrirAcoes () {
      return (!this.funcionalidade.parametros.configuracoesDeWidgets.permiteEnvioChatWidget && !this.funcionalidade.parametros.configuracoesDeWidgets.permiteEnvioEmailWidget && !this.funcionalidade.parametros.configuracoesDeWidgets.permiteEnvioWhatsappWidget)
    }
  },
  methods: {
    clickDetalhe (row) {
      return this.$router.push({
        path: '/14/detalhe',
        query: {
          idTitulo: row['idTitulo'],
          codigoTitulo: row['codigoTitulo'],
          nome: row['descricao']
        }
      })
    },
    async abreDialogEnvio () {
      this.mostraEnvio = true
    },
    carregaPayloadWidget (row) {
      return preloadWidget(
        row,
        this.funcionalidade,
        this.embedJson.atendimento.tokenAtendente
      )
    }
  }
}
</script>
